const selectNativeWorker = () => {
  const selectWrapperItems = document.querySelectorAll('.form-select__wrapper');

  for (const selectWrapper of selectWrapperItems) {
    const span = document.createElement('span');
    const selectNative = selectWrapper.querySelector('select');

    selectWrapper.appendChild(span);
    if (span) {
      span.addEventListener('mousedown', (event) => {
        setTimeout(() => {
          selectNative.dispatchEvent(event);
        });
      });
    }
  }
};

export default selectNativeWorker();
